"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coerceNumber = exports.valueToString = exports.areValuesEqual = exports.isBooleanValue = exports.isStringValue = exports.isNumberValue = exports.isArrayValue = void 0;
var utils_1 = require("../types/utils");
var evaluationErrors_1 = require("./evaluationErrors");
// See: https://www.typescriptlang.org/docs/handbook/advanced-types.html#user-defined-type-guards
/**
 * A type guard that checks if the value is an {@link ArrayValue}.
 */
function isArrayValue(value) {
    return utils_1.isArrayType(value.type);
}
exports.isArrayValue = isArrayValue;
/**
 * A type guard that checks if the value is an {@link NumberValue}.
 */
function isNumberValue(value) {
    return utils_1.isNumberType(value.type);
}
exports.isNumberValue = isNumberValue;
/**
 * A type guard that checks if the value is an {@link StringValue}.
 */
function isStringValue(value) {
    return utils_1.isStringType(value.type);
}
exports.isStringValue = isStringValue;
/**
 * A type guard that checks if the value is an {@link BooleanValue}.
 */
function isBooleanValue(value) {
    return utils_1.isBooleanType(value.type);
}
exports.isBooleanValue = isBooleanValue;
/**
 * Checks if two value objects are equal.
 *
 * Primitive values are considered equal if their underlying values are strictly equal.
 *
 * Array values are equal if they are the same length and each of their elements (in order) are equal.
 */
function areValuesEqual(left, right) {
    if (isArrayValue(left) || isArrayValue(right)) {
        return isArrayValue(left) && isArrayValue(right) && elementsEqual(left.elements, right.elements);
    }
    else {
        return left.value === right.value;
    }
}
exports.areValuesEqual = areValuesEqual;
function elementsEqual(left, right) {
    if (left.length !== right.length) {
        return false;
    }
    for (var i = 0; i < left.length; i++) {
        if (!areValuesEqual(left[i], right[i])) {
            return false;
        }
    }
    return true;
}
/**
 * Converts a value object to a string.
 *
 * String values have their underlying values returned.
 *
 * Number values are converted to decimal numeric strings.
 *
 * Boolean values are converted to the strings "true" or "false".
 *
 * Array values have their elements passed to {@code valueToString} and joined by commas.
 */
function valueToString(v) {
    if (isStringValue(v))
        return v.value;
    if (isNumberValue(v))
        return v.value.toString();
    if (isBooleanValue(v))
        return v.value ? "true" : "false";
    if (isArrayValue(v))
        return v.elements.map(valueToString).join(", ");
    throw new Error("Unable to convert value to string");
}
exports.valueToString = valueToString;
/**
 * Attempts to coerce a number from the given value.
 *
 * If the value is a {@link NumberValue}, the number is passed through.
 * If the value is a {@link StringValue}, the string is stripped of commas and, if it matches the format of a number, parsed as a float.
 * Otherwise, an error is thrown.
 *
 * @param value The value to convert
 * @throws NumericError if the value cannot be converted into a number.
 * @returns The number representation of the value
 */
function coerceNumber(value) {
    if (isNumberValue(value)) {
        return value.value;
    }
    else if (isStringValue(value)) {
        // strip commas, as a convenience for the end-user
        var s = value.value.replace(/,/g, "");
        if (/^-?\d*(\.\d*)?$/.test(s)) {
            var res = parseFloat(s);
            if (!isNaN(res)) {
                return res;
            }
        }
    }
    throw new evaluationErrors_1.NumericError();
}
exports.coerceNumber = coerceNumber;
//# sourceMappingURL=util.js.map